import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import MaterialIcon from 'commons/src/components/MaterialIcon';
import styles from './mqttPublisher.module.scss';

type Props = {
    label: string;
    file: File | undefined;
    onChange: (f: File | undefined) => void;
    accept: string;
    showValidation: boolean;
    existingFileName?: string;
};

const FileUploadField = ({
    label,
    file,
    onChange,
    accept,
    showValidation,
    existingFileName,
}: Props): React.ReactElement => {
    const { t: txt } = useTranslation();
    const inputRef = useRef<HTMLInputElement>(null) as React.RefObject<HTMLInputElement>;

    const triggerFileDialog = (): void => inputRef.current?.click();
    const fileName = file?.name || existingFileName;

    return (
        <div className={styles.fileUpload}>
            <span className={styles.fileUpload__label}>{txt(label)}</span>
            {showValidation && !file && (
                <span className={styles.fileUpload__hint}>{txt('MqttPublisher.FileRequired')}</span>
            )}
            <div
                role="button"
                tabIndex={0}
                className={`${styles.fileUpload__dropzone} ${fileName ? styles['fileUpload__dropzone--hasFile'] : ''}`}
                onClick={triggerFileDialog}
                onKeyUp={(e): void => {
                    if (e.key === 'Enter') triggerFileDialog();
                }}
            >
                {fileName ? (
                    <>
                        <MaterialIcon name="description" />
                        {fileName}
                    </>
                ) : (
                    <>
                        <MaterialIcon name="upload" />
                        {txt('MqttPublisher.NoFileUploaded')}
                    </>
                )}
            </div>
            <input
                ref={inputRef}
                type="file"
                accept={accept}
                className={styles.fileUpload__hidden}
                onChange={(e): void => {
                    const selected = e.target.files?.[0];
                    if (selected) onChange(selected);
                }}
            />
        </div>
    );
};

export default FileUploadField;
